import { Assignee, AssigneeType, PropertyClient } from 'api/clients/PropertyClient'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { TreeFile } from 'screens/Finder/FinderContextTypes'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { setFilesPropertiesLoadingState, upsertFilesProperties } from 'redux/actions/filesProperties'
import { AlmanacFile as File, FetchRequestState, AlmanacFileSummary } from 'types'
import { reportError } from 'utils/error'

export const useLoadAssignedProperties = () => {
  const dispatch = useDispatch()
  const fileToAssignee = ({ id, type }: File | TreeFile | AlmanacFileSummary) => {
    let assigneeType

    if (type in AssigneeType) assigneeType = type

    switch (type) {
      case 'folder':
        assigneeType = AssigneeType.Project
        break
      case 'article':
        assigneeType = AssigneeType.Article
        break
      case 'media_file':
        assigneeType = AssigneeType.MediaFile
        break
      case 'design':
        assigneeType = AssigneeType.Design
        break
    }

    return {
      id,
      type: assigneeType,
    } as Assignee
  }

  const loadAssignedProperties = useCallback(
    async (files: File[] | AlmanacFileSummary[], propertiesIds: number[]) => {
      if (files.length === 0) return

      let assignees: Assignee[] = []
      files.forEach((file) => {
        assignees.push(fileToAssignee(file))
        if ('branches' in file) {
          file.branches?.forEach((branch) => {
            assignees.push(fileToAssignee(branch))
          })
        }
      })

      dispatch(setFilesPropertiesLoadingState(assignees, propertiesIds, FetchRequestState.Loading))

      const res = await PropertyClient.getBatchAssignedProperties(assignees, propertiesIds)
      if (res.type === SUCCESS_RESPONSE_TYPE) {
        dispatch(upsertFilesProperties(res.data.assigned_properties))
        dispatch(setFilesPropertiesLoadingState(assignees, propertiesIds, FetchRequestState.Resolved))
      } else {
        reportError('Failed to fetch assigned properties', {
          severity: 'error',
          metaData: { assignees, propertiesIds },
        })
        dispatch(setFilesPropertiesLoadingState(assignees, propertiesIds, FetchRequestState.Rejected))
      }
    },
    [dispatch],
  )

  return {
    loadAssignedProperties,
    fileToAssignee,
  }
}
